<section class="section-background section-border">
  <table mat-table [dataSource]="dataSource">
    <!--- Note that these columns can be defined in any order.
      The actual rendered columns are set as a property on the row definition" -->

    <!-- Position Column -->
    <ng-container matColumnDef="documents">
      <th class="w-25" mat-header-cell *matHeaderCellDef>Document(s)</th>
      <td class="w-25" mat-cell *matCellDef="let element">
        {{ element?.documentType }}
      </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="fileName">
      <th mat-header-cell *matHeaderCellDef>File name</th>
      <td mat-cell *matCellDef="let element">
        <div class="file-name">
          <a
            (click)="$event.stopPropagation()"
            [routerLink]=""
            (click)="onOpenFile(element)"
            >{{ element?.document?.name }}</a
          >
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</section>
